// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/select_arow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/ongoing.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/sold.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.popUp_dashboard__3Ij9R {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  overflow-y: auto;
  padding-right: 0px;
}

.popUp_dashboardContain__V602m {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.popUp_bodythemedark__nZv4W .popUp_dashboardContain__V602m,
.popUp_bodythemedark__nZv4W .popUp_dashboard__3Ij9R,
.popUp_bodythemedark__nZv4W .popUp_cont2__BCPQ- {
  background-Color: #0f1824;
}

.popUp_top_header__8GWXZ .popUp_top_header_inner__fiq7r {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.popUp_cont2__BCPQ- {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  /*height: calc(100vh - 160px);*/
  height: 100%;
  min-height: auto !important;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.popUp_subLink__KX4-k svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.popUp_cst_vendr__9Wow3 input {
  min-height: 35px !important;
}

.popUp_cst_vendr__9Wow3 .popUp_form-control__YvXVG {
  background-color: #f5f6fa;
  border: none;
}

.popUp_footer__ZUYud {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.popUp_bodythemelight__pD1y9 {
  background-color: #fff;
  padding-top: 90px;
}

.popUp_bodythemedark__nZv4W {
  background-color: #132337;
  padding-top: 90px;
}

.popUp_bodythemeNew__Ytun1 {
  background-color: #f5f6fa;
}

/* 
Header Navbar Theme
*/
.popUp_headerthemelight__d3vR2 {
  background-color: #fff;
}

.popUp_headerthemedark__1\\+ZIW {
  background-color: #132337;
}

.popUp_top_header__8GWXZ {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 2;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.popUp_menuthemelight__EUIuy {
  background-color: #f5f6fa;
}

.popUp_menuthemedark__zXXQk {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.popUp_menulinklight__wLERK span {
  color: #666666 !important;
}

.popUp_menulinklight__wLERK a {
  color: #CBCBCB !important;
}

.popUp_menulinklight__wLERK:hover span,
.popUp_menulinklight__wLERK:hover a {
  color: #fff !important;
}

.popUp_menulinkdarkSelected__OnjGw {
  background-color: #1c2e45;
  color: #3b82f6;
}

.popUp_menuthemelight__EUIuy .popUp_menulinklightSelected__1R1za {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43 !important;
}

.popUp_menulinkdark__4cS5c {
  color: #92afd3 !important;
}

.popUp_menulinklight__wLERK:hover {
  color: #fff !important;
  background-color: #131F43 !important;
}

.popUp_menulinklight__wLERK .popUp_sub_arrow__2mF5H svg path {
  stroke: #CBCBCB !important;
}

.popUp_menulinklight__wLERK:hover .popUp_sub_arrow__2mF5H svg path {
  stroke: #fff !important;
}

.popUp_menulinkdark__4cS5c .popUp_sub_arrow__2mF5H svg path {
  stroke: #92afd3 !important;
}

.popUp_menulinkdark__4cS5c:hover .popUp_sub_arrow__2mF5H svg path {
  stroke: #fff !important;
}

.popUp_menulinklight__wLERK:hover svg path,
.popUp_menulinklightSelected__1R1za svg path {
  fill: #fff !important;
}

.popUp_menulinkdark__4cS5c:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.popUp_headinglight__OPKl3 {
  color: #60677e;
}

.popUp_headingdark__C2zJq {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.popUp_searchboxlight__EnlnJ {
  background-color: #fff;
  border: none;
}

.popUp_searchboxdark__RFGE6 {
  background-color: #132337;
  color: #fff;
  border: none;
}

.popUp_searchboxdark__RFGE6::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.popUp_tableheadlight__ANyxy {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.popUp_tableheadlight__ANyxy th {
  color: #fff;
}

thead .popUp_tableheadlight__ANyxy th:first-child,
thead .popUp_tableheaddark__oLS07 th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .popUp_tableheadlight__ANyxy th:last-child,
thead .popUp_tableheaddark__oLS07 th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.popUp_table__maPf9.popUp_table-borderless__ngQfF {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.popUp_tableheaddark__oLS07 {
  background-color: #132337;
  color: #fff;
}

.popUp_table-borderless__ngQfF tr:nth-child(even) {
  background-color: #F9FAFB;
}

.popUp_table-borderless__ngQfF .popUp_left-section__2\\+ivL {
  padding-top: 10px;
}

.popUp_tablebodylight__r-oh1 td,
.popUp_tablebodydark__UVOm9 td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.popUp_tablebodylight__r-oh1 {
  background-color: #fff;
}
.popUp_tablebodylight__r-oh1:hover {
  background-color: #fff;
  cursor: auto;
}
.popUp_tablebodylight__r-oh1 p {
  line-height: 24px;
}

.popUp_tablebodydark__UVOm9 {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.popUp_tablebodydark__UVOm9:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: pointer;
}

/* 
PAGINATION THEME COLOR
*/
.popUp_paginationlight__ndAsc {
  color: #60677e !important;
  font-size: 13px !important;
}

.popUp_paginationdark__1xGwh {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.popUp_formthemelight__Vk1OI {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.popUp_formthemedark__aQbIu {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.popUp_formthemedark__aQbIu ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.popUp_viewformlight__WGO5b {
  background-color: #f3f6f9;
}

.popUp_permissionboxlight__oCdaW {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.popUp_permissionboxdark__ECH20 {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.popUp_errormsgclr__Oraf6 {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.popUp_graphclrlight__f57pk {
  background-color: #fff;
}

.popUp_graphclrdark__-SN00 {
  background-color: #132337;
}

/* 
Counter theme
*/
#popUp_card1bglight__J6dAZ {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#popUp_card1bgdark__p1Sbz {
  background: #392f28;
}

#popUp_card2bglight__Lluls {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#popUp_card2bgdark__XMlZp {
  background: #1c3238;
}

#popUp_card3bglight__4-tEj {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#popUp_card3bgdark__LRWE1 {
  background: #3a2434;
}

#popUp_card4bglight__KdKB6 {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#popUp_card4bgdark__V5sbe {
  background: #2f264f;
}

#popUp_card1bgdark__p1Sbz a,
#popUp_card1bgdark__p1Sbz p,
#popUp_card2bgdark__XMlZp a,
#popUp_card2bgdark__XMlZp p,
#popUp_card3bgdark__LRWE1 a,
#popUp_card3bgdark__LRWE1 p,
#popUp_card4bgdark__V5sbe a,
#popUp_card4bgdark__V5sbe p {
  color: #fff;
}

/* 
Action button theme
*/
.popUp_actionbtnlight__dsGjO {
  color: rgba(70, 71, 91, 0.8705882353);
}

.popUp_actionbtndark__aGBaO {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.popUp_profiledropdownlight__lEFlW {
  background-color: #fff;
}

.popUp_profiledropdowndark__VgGri {
  background-color: #151521;
}

.popUp_settingsection__qcJda #popUp_addform__pHtis.popUp_formthemedark__aQbIu .popUp_savebtn__H5Vpd {
  background-color: #3b82f6;
  color: #fff;
}

#popUp_addform__pHtis.popUp_formthemedark__aQbIu .popUp_savebtn__H5Vpd {
  background-color: #3b82f6;
  color: #fff;
}

.popUp_profile_conatiner__ZnC5R {
  border-radius: 5px !important;
}

.popUp_bodythemedark__nZv4W .popUp_ag-theme-alpine__midEU .popUp_ag-row__Y5pQu {
  background: #000 !important;
}

.popUp_bodythemedark__nZv4W .popUp_formbtn__VxNBo {
  background-color: #3b82f6;
}

.popUp_bodythemedark__nZv4W .popUp_formbtn__VxNBo:hover {
  background-color: #2563eb;
}

.popUp_bodythemedark__nZv4W .popUp_resetbtn__mHYqk {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.popUp_bodythemedark__nZv4W .popUp_resetbtn__mHYqk:hover {
  background-color: #3b82f6;
}

.popUp_headingdark__C2zJq span {
  background-color: #132337;
}

.popUp_resetbtn__mHYqk {
  font-size: 16px !important;
  font-weight: 600 !important;
  border-radius: 5px !important;
  background-color: transparent !important;
  border: solid 1px #131F43 !important;
  color: #131F43 !important;
  min-width: 113px !important;
}

.popUp_resetbtn__mHYqk:hover,
.popUp_resetbtn__mHYqk:active,
.popUp_resetbtn__mHYqk:focus {
  background-color: #131F43 !important;
  color: #fff !important;
}

.popUp_addBtn__Kuvu2 {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.popUp_addDltBtn__02gc4 {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.popUp_addbtnlight__yS-uI {
  background-color: #38A169;
}

.popUp_addbtndark__I3s-O {
  background-color: #3b82f6;
}

.popUp_addbtndark__I3s-O:hover {
  background-color: #2563eb;
}

.popUp_formthemedark__aQbIu label {
  color: #92afd3;
}

.popUp_addBtn__Kuvu2 svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.popUp_addBtn__Kuvu2:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.popUp_cust_addBtn__BJ8f6.popUp_addBtn__Kuvu2 svg {
  top: 2px;
}

.popUp_deleteBtn__LO2TU {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.popUp_deleteBtn__LO2TU {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.popUp_deleteBtn__LO2TU:active,
.popUp_deleteBtn__LO2TU:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.popUp_deleteBtn__LO2TU svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.popUp_deleteBtn__LO2TU:hover,
.popUp_deleteBtn__LO2TU:active,
.popUp_deleteBtn__LO2TU:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.popUp_confirmBtn__tqH8G {
  background-color: #131F43 !important;
  min-width: 130px !important;
  height: 50px !important;
  color: #fff !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border: none !important;
}

.popUp_confirmBtn__tqH8G:hover,
.popUp_confirmBtn__tqH8G:active,
.popUp_confirmBtn__tqH8G:focus {
  background-color: #0f1824 !important;
}

.popUp_confirmBtn__tqH8G svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.popUp_delPopContainer__7Ojbb .popUp_modal-body__7h3Gn {
  padding: 35px;
  text-align: center;
}

.popUp_delPopContainer__7Ojbb .popUp_delet_icon__XqV-q {
  margin-bottom: 11px;
}

.popUp_delPopContainer__7Ojbb p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
  padding: 0 20px;
}

.popUp_arrowback__LBq8d svg {
  fill: #000;
}

.popUp_bodythemedark__nZv4W .popUp_arrowback__LBq8d {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.popUp_bodythemedark__nZv4W .popUp_arrowback__LBq8d svg {
  fill: #3b82f6;
}

.popUp_bodythemedark__nZv4W .popUp_drpdwn_btn__Oils\\+ {
  background-color: #132337;
}

.popUp_bodythemedark__nZv4W .popUp_empname__xTq2C {
  color: #92afd3 !important;
}

.popUp_bodythemedark__nZv4W .popUp_navitemli__heV5- a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.popUp_bodythemedark__nZv4W .popUp_tabnavli__uxVyN a.popUp_settingsgeneral__1T7YT,
.popUp_bodythemedark__nZv4W .popUp_tabnavli__uxVyN a.popUp_settingslinks__JSeOh:hover {
  background-color: #3b82f6;
  color: #fff;
}

.popUp_bodythemedark__nZv4W .popUp_tabnavli__uxVyN a.popUp_settingslinks__JSeOh {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.popUp_headerthemedark__1\\+ZIW .popUp_dropdown_menu_contain__9GtSg {
  background-color: #1c2e45;
  color: #fff;
}

.popUp_headerthemedark__1\\+ZIW .popUp_dropdown_menu_contain__9GtSg ul li a,
.popUp_headerthemedark__1\\+ZIW .popUp_dropdown_menu_contain__9GtSg .popUp_dropdown_item__0mnfC,
.popUp_headerthemedark__1\\+ZIW .popUp_dropdown_menu_contain__9GtSg .popUp_dropdown_item__0mnfC h5 {
  color: #fff;
}

.popUp_headerthemedark__1\\+ZIW .popUp_dropdown_menu_contain__9GtSg ul li a:hover,
.popUp_headerthemedark__1\\+ZIW .popUp_dropdown_menu_contain__9GtSg .popUp_dropdown_item__0mnfC:hover {
  background-color: #132337;
  color: #fff;
}

.popUp_dropdown_item__0mnfC:active {
  background-color: #F5F6FA;
}

.popUp_profile_arrrow_dwn__g2FtD {
  stroke: #132337;
}

.popUp_headerthemedark__1\\+ZIW .popUp_profile_arrrow_dwn__g2FtD {
  stroke: #fff;
}

.popUp_dateinputbox1__rdLzw input,
.popUp_dateinputbox1__rdLzw span {
  color: #fff !important;
}

/* LOGOUT MODAL */
.popUp_delPopContainer__7Ojbb .popUp_modal-content__BzrXf {
  border-radius: 10px;
  min-width: 399px;
}

.popUp_larg_model__zvTr0 .popUp_modal-dialog__qYhPE {
  max-width: 100% !important;
}

.popUp_larg_model__zvTr0 .popUp_modal-content__BzrXf {
  /* display: inline-block; */
  height: 100%;
  max-width: 900px;
  margin: auto;
  border-radius: 54px !important;
  background: #FFF;
  padding: 53px 53px 23px;
}

.popUp_larg_model__zvTr0 .popUp_modal-header__de44j {
  padding: 0px 0px 23px;
  border-bottom: 1px dashed #D4D9EE;
  display: block;
}

body .popUp_btn-primary__tzQj2:hover {
  background-color: transparent;
  border-color: #131F43;
  color: #131F43;
  fill: #131F43;
  border: 1px solid;
}

.popUp_form-select__WysRJ {
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  -moz-padding-start: calc(0.75rem - 3px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

thead .popUp_CustomTable_tableheadlight__HuHZw__XxSbr th:first-child,
thead .popUp_CustomTable_tableheaddark__nwqb4__z6gn7 th:first-child {
  border-radius: 5px 0 0 0px;
  display: math;
}

th:first-child {
  border-radius: 0px;
  position: absolute;
}

@media only screen and (max-width: 1200px) {
  .popUp_tableheadlight__ANyxy th {
    min-width: 270px;
  }
}
@media only screen and (max-width: 1024px) {
  .popUp_dashboard__3Ij9R {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
    overflow-x: hidden !important;
  }
  .popUp_cont2__BCPQ- {
    height: auto !important;
    padding-bottom: 10px !important;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
    height: auto !important;
  }*/
}
@media only screen and (max-width: 767px) {
  .popUp_sectionright__YFeeu {
    float: unset !important;
  }
  .popUp_dashboard__3Ij9R {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .popUp_cont2__BCPQ- {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px 10px 15px !important;
  }
  .popUp_bodythemelight__pD1y9,
.popUp_bodythemedark__nZv4W {
    padding-top: 110px;
  }
  .popUp_delPopContainer__7Ojbb .popUp_modal-content__BzrXf {
    min-width: 100%;
  }
  .popUp_delPopContainer__7Ojbb .popUp_modal-body__7h3Gn {
    padding: 15px;
  }
  .popUp_larg_model__zvTr0 .popUp_modal-content__BzrXf {
    border-radius: 20px !important;
    padding: 22px;
  }
}
@media (min-width: 576px) {
  .popUp_exer_modal_contain__ZZRQD .popUp_modal-dialog__qYhPE {
    max-width: 1055px;
  }
  .popUp_delPopContainer__7Ojbb .popUp_modal-dialog__qYhPE {
    max-width: 350px;
  }
  /*.tableheadlight th {
    min-width: 120px;
  } */
}
/* vk new changes */
.popUp_active_show_outer__Ond1F h2 {
  color: var(--Font-black, #0B0D0F);
  font-family: Urbanist;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
@media screen and (max-width: 768px) {
  .popUp_active_show_outer__Ond1F h2 {
    margin-top: 15px;
  }
}
.popUp_active_show_outer__Ond1F .popUp_active_show_inner__3Fg48 {
  width: 100%;
  display: block;
}
.popUp_active_show_outer__Ond1F .popUp_active_show_inner__3Fg48 .popUp_act_box_img__uWXDH {
  margin-bottom: 12px;
  min-height: 400px;
  object-fit: cover;
  overflow: hidden;
  height: 400px;
  max-height: 400px;
}
@media (max-width: 767px) {
  .popUp_active_show_outer__Ond1F .popUp_active_show_inner__3Fg48 .popUp_act_box_img__uWXDH {
    min-height: 300px;
    height: 300px;
    max-height: 300px;
  }
}
.popUp_active_show_outer__Ond1F .popUp_active_show_inner__3Fg48 .popUp_act_box_img__uWXDH img {
  max-height: 400px;
  /* align-self: stretch; */
  width: 100%;
  height: 100%;
  border-radius: 12px;
  object-fit: cover;
}
.popUp_active_show_outer__Ond1F .popUp_active_show_inner__3Fg48 .popUp_act_box_cnt__OuM3J {
  width: 100%;
  display: block;
}
.popUp_active_show_outer__Ond1F .popUp_active_show_inner__3Fg48 .popUp_act_box_cnt__OuM3J svg {
  flex-shrink: 0;
}
.popUp_active_show_outer__Ond1F .popUp_active_show_inner__3Fg48 .popUp_act_box_cnt__OuM3J .popUp_act_box_bdg__Fzt3y {
  width: 100%;
  margin-bottom: 12px;
}
.popUp_active_show_outer__Ond1F .popUp_active_show_inner__3Fg48 .popUp_act_box_cnt__OuM3J .popUp_act_box_bdg__Fzt3y span {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right top no-repeat;
  width: 111px;
  display: block;
  height: 34px;
  color: var(--White, #FFF);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  padding: 3px 8px;
}
.popUp_active_show_outer__Ond1F .popUp_active_show_inner__3Fg48 .popUp_act_box_cnt__OuM3J .popUp_act_box_bdg__Fzt3y .popUp_sold__C1TUM {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) right top no-repeat !important;
}
.popUp_active_show_outer__Ond1F .popUp_active_show_inner__3Fg48 .popUp_act_box_cnt__OuM3J h3 {
  color: var(--Secondary, #132941);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 26.304px;
  margin: 0;
}
.popUp_active_show_outer__Ond1F .popUp_active_show_inner__3Fg48 .popUp_act_box_cnt__OuM3J p {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
}
.popUp_active_show_outer__Ond1F .popUp_active_show_inner__3Fg48 .popUp_act_box_cnt__OuM3J p span {
  color: var(--Light-1, #736B66);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 26.304px;
}
.popUp_active_show_outer__Ond1F .popUp_active_show_inner__3Fg48 .popUp_act_box_cnt__OuM3J p .popUp_timezone_code_pill__\\+BfgM {
  display: inline-block;
  padding: 2px 8px;
  margin-left: 4px;
  background: #e0f2fe;
  color: #0369a1;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  border-radius: 6px;
}

/* vk new changes */
#popUp_attent_details_row1__OmW1Q {
  margin-bottom: 0 !important;
}

.popUp_attent_details__oY7LF .popUp_attent_details_inner__4TV6V {
  display: flex;
  gap: 61px;
  padding: 20px;
  border-radius: 5px;
  background: #FFF;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
  align-items: center;
}
@media (max-width: 576px) {
  .popUp_attent_details__oY7LF .popUp_attent_details_inner__4TV6V {
    display: block !important;
  }
}
@media (max-width: 992px) {
  .popUp_attent_details__oY7LF .popUp_attent_details_inner__4TV6V {
    display: flex;
    gap: 20px;
    align-items: start;
  }
}
.popUp_attent_details__oY7LF .popUp_attent_details_inner__4TV6V .popUp_attent_details_inner_l__22Rj8 img {
  width: 187px;
  height: 207px;
  flex-shrink: 0;
  object-fit: cover;
}
.popUp_attent_details__oY7LF .popUp_attent_details_inner__4TV6V .popUp_attent_details_inner_r__EvMDI {
  flex: 1 1;
}
.popUp_attent_details__oY7LF .popUp_attent_details_inner__4TV6V .popUp_attent_details_inner_r__EvMDI .popUp_attent_details_row__UBvk2 {
  display: flex;
  gap: 20px;
  margin-bottom: 28px;
}
@media (max-width: 992px) {
  .popUp_attent_details__oY7LF .popUp_attent_details_inner__4TV6V .popUp_attent_details_inner_r__EvMDI .popUp_attent_details_row__UBvk2 {
    margin-bottom: 0px;
    display: inline-block;
    width: 100%;
  }
}
.popUp_attent_details__oY7LF .popUp_attent_details_inner__4TV6V .popUp_attent_details_inner_r__EvMDI .popUp_attent_details_row__UBvk2 .popUp_attent_details_row_box__Co\\+rI {
  flex: 1 1;
  width: 22%;
}
@media (max-width: 576px) {
  .popUp_attent_details__oY7LF .popUp_attent_details_inner__4TV6V .popUp_attent_details_inner_r__EvMDI .popUp_attent_details_row__UBvk2 .popUp_attent_details_row_box__Co\\+rI {
    margin: 15px 0px 10px !important;
    width: 100% !important;
  }
}
@media (max-width: 992px) {
  .popUp_attent_details__oY7LF .popUp_attent_details_inner__4TV6V .popUp_attent_details_inner_r__EvMDI .popUp_attent_details_row__UBvk2 .popUp_attent_details_row_box__Co\\+rI {
    margin-bottom: 15px;
    float: left;
    margin-right: 0;
    width: 50%;
    padding-right: 10px;
  }
}
.popUp_attent_details__oY7LF .popUp_attent_details_inner__4TV6V .popUp_attent_details_inner_r__EvMDI .popUp_attent_details_row__UBvk2 .popUp_attent_details_row_box__Co\\+rI p {
  margin-bottom: 10px;
  color: #727272;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.popUp_attent_details__oY7LF .popUp_attent_details_inner__4TV6V .popUp_attent_details_inner_r__EvMDI .popUp_attent_details_row__UBvk2 .popUp_attent_details_row_box__Co\\+rI h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  word-wrap: break-word;
}
.popUp_attent_details__oY7LF .popUp_attent_details_inner__4TV6V .popUp_attent_details_inner_r__EvMDI .popUp_attent_details_row_last__yThjj {
  margin-bottom: 0px !important;
}
.popUp_attent_details__oY7LF .popUp_attent_details_inner__4TV6V .popUp_attent_details_inner_r__EvMDI .popUp_attent_details_row_last__yThjj.popUp_interesting_fact__VtS2n {
  padding-top: 30px;
}
.popUp_attent_details__oY7LF .popUp_attent_details_inner__4TV6V .popUp_attent_details_inner_r__EvMDI .popUp_attent_details_row_last__yThjj.popUp_interesting_fact__VtS2n .popUp_attent_details_row_box__Co\\+rI {
  width: 100%;
}
.popUp_attent_details__oY7LF .popUp_attent_details_inner__4TV6V .popUp_attent_details_inner_r__EvMDI .popUp_attent_details_row_last__yThjj.popUp_interesting_fact__VtS2n .popUp_attent_details_row_box__Co\\+rI h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.popUp_showbox_sec__cvztP {
  display: flex;
  justify-content: flex-start;
  gap: 0;
  flex-direction: row;
  flex-wrap: wrap;
}
@media screen and (max-width: 500px) {
  .popUp_showbox_sec__cvztP {
    justify-content: center;
  }
}

.popUp_show_box_main__u8eKG {
  margin: 10px 0px;
}
.popUp_show_box_main__u8eKG .popUp_show_box__4KLoV {
  min-height: 600px;
  width: 300px;
  float: left;
  margin-right: 20px;
  margin-bottom: 20px;
  cursor: pointer;
}
@media (max-width: 1024px) {
  .popUp_show_box_main__u8eKG .popUp_show_box__4KLoV {
    margin-right: 18px;
  }
}
@media (max-width: 767px) {
  .popUp_show_box_main__u8eKG .popUp_show_box__4KLoV {
    min-height: 500px;
    width: 200px !important;
  }
}
.popUp_show_box_main__u8eKG .popUp_show_box__4KLoV img {
  max-height: 400px;
  height: 100%;
  width: 100%;
}
@media (max-width: 767px) {
  .popUp_show_box_main__u8eKG .popUp_show_box__4KLoV img {
    max-height: 300px !important;
  }
}
.popUp_show_box_main__u8eKG .popUp_show_box__4KLoV:last-child {
  margin-right: 0px !important;
}
.popUp_show_box_main__u8eKG .popUp_no_show_box__BXtSG {
  width: 350px;
  margin: 0 auto 20px;
  display: block;
}
@media (max-width: 767px) {
  .popUp_show_box_main__u8eKG .popUp_no_show_box__BXtSG {
    width: 250px !important;
  }
}
.popUp_show_box_main__u8eKG .popUp_no_show_box__BXtSG img {
  max-height: 450px;
  height: 100%;
  width: 100%;
}
@media (max-width: 767px) {
  .popUp_show_box_main__u8eKG .popUp_no_show_box__BXtSG img {
    max-height: 350px !important;
  }
}
.popUp_show_box_main__u8eKG .popUp_no_show_box__BXtSG h6 {
  color: #000;
  text-align: center;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 20px;
}
@media only screen and (max-width: 600px) {
  .popUp_show_box_main__u8eKG .popUp_no_show_box__BXtSG h6 {
    font-size: 20px;
  }
}

.popUp_attent_flex__N\\+p3a {
  justify-content: space-between !important;
  gap: 30px;
  align-items: center;
}
.popUp_attent_flex__N\\+p3a h5 {
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
}

.popUp_pop_head__B9w2T {
  display: flex;
  justify-content: space-between;
}
.popUp_pop_head__B9w2T h4 {
  color: #0B0D0F;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0;
}
.popUp_pop_head__B9w2T .popUp_pop_close__bbeGt {
  padding: 0;
  margin: 0;
  background: none;
  border: none !important;
  cursor: pointer;
}
.popUp_pop_head__B9w2T .popUp_pop_close__bbeGt svg {
  width: 26px;
  height: 26px;
}

.popUp_pop_close__bbeGt:hover {
  background-color: transparent !important;
  border-color: transparent !important;
}

.popUp_resetbtn__mHYqk {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #131F43;
  color: #131F43;
  min-width: 113px;
  min-height: 50px;
  margin-right: 24px;
}

.popUp_resetbtn__mHYqk svg {
  margin-right: 10px;
  position: relative;
  top: -1px;
}

.popUp_resetbtn__mHYqk:hover svg,
.popUp_resetbtn__mHYqk:active svg,
.popUp_resetbtn__mHYqk:focus svg {
  fill: #fff;
}

.popUp_pop_cnt__hshzK .popUp_from_group__1\\+kyU button {
  text-align: center !important;
}

.popUp_from_groupone__u5n0x {
  text-align: center !important;
}

.popUp_formthemeStylesec__rdidi {
  box-shadow: none;
  padding: 26px 0;
}

.popUp_pop_cnt__hshzK .popUp_from_group__1\\+kyU {
  margin-bottom: 30px;
}
.popUp_pop_cnt__hshzK .popUp_from_group__1\\+kyU label {
  color: #727272;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-bottom: 16px;
}
.popUp_pop_cnt__hshzK .popUp_from_group__1\\+kyU .popUp_from_control__f7OII {
  border-radius: 5px;
  background-color: #F5F6FA;
  color: #727272;
  font-size: 16px;
  font-style: normal;
  padding: 15px;
  font-weight: 500;
  line-height: normal;
  height: 50px;
  width: 100%;
  border: none;
}
.popUp_pop_cnt__hshzK .popUp_from_group__1\\+kyU ::placeholder {
  color: #727272;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.popUp_pop_cnt__hshzK .popUp_from_group__1\\+kyU .popUp_drag_label__iSKS6 {
  color: #727272;
  font-size: 10.184px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.popUp_pop_cnt__hshzK .popUp_from_group__1\\+kyU .popUp_image_drag__OJ-Pw {
  display: flex;
  width: 100%;
  height: 219.693px;
  padding: 0 15px;
  flex-direction: column;
  align-items: center;
  gap: 7.275px;
  border-radius: 3.637px;
  background: #F5F6FA;
}
.popUp_pop_cnt__hshzK .popUp_from_group__1\\+kyU .popUp_image_drag__OJ-Pw .popUp_image_drag_inner__2RTI1 {
  width: 100%;
  text-align: center;
}
.popUp_pop_cnt__hshzK .popUp_from_group__1\\+kyU .popUp_image_drag__OJ-Pw .popUp_image_drag_inner__2RTI1 label {
  width: 100%;
  height: 219.693px;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.popUp_pop_cnt__hshzK .popUp_from_group__1\\+kyU .popUp_image_drag__OJ-Pw .popUp_image_drag_inner__2RTI1 h6 {
  margin: 0;
}
.popUp_pop_cnt__hshzK .popUp_from_group__1\\+kyU .popUp_image_drag__OJ-Pw .popUp_image_drag_inner__2RTI1 h6 svg {
  width: 40.738px;
  height: 40.738px;
}
.popUp_pop_cnt__hshzK .popUp_from_group__1\\+kyU .popUp_image_drag__OJ-Pw .popUp_image_drag_inner__2RTI1 h5 {
  color: #727272;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  margin: 0;
  line-height: normal;
}

.popUp_from_group__1\\+kyU .addBtn:hover {
  color: #fff !important;
}

.popUp_upload_btn__oB21G {
  display: inline-block;
  border: 1px solid #ced4da;
  color: #60677e;
  padding: 5px 10px;
  font-size: 14px;
  border-radius: 5px;
  cursor: pointer;
}

.popUp_uploaded_imgsection__ETzXB {
  width: 100px;
  height: 150px;
}

#popUp_uploaded_img__E3uJL {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.popUp_imgcancel_btn__gQW95 {
  border: none;
  font-size: 14px;
  padding: 5px 30px;
  background-color: #e2e3e7;
  margin-top: 5px;
  border-radius: 5px;
}
.popUp_imgcancel_btn__gQW95:hover {
  background-color: #a9a9a9;
}

@media only screen and (max-width: 360px) {
  .popUp_resetbtn__mHYqk {
    min-width: 100px;
    margin-right: 15px;
  }
  .popUp_deleteBtn__LO2TU {
    min-width: 100px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/components/PopUp/popUp.module.scss"],"names":[],"mappings":"AAAA;;EAAA;AAkDA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA1FO;EA2FP,gBAAA;EACA,kBAAA;ACvEF;;AD0EA;EACE,yBAAA;EACA,yBAjGO;EAkGP,kBAAA;ACvEF;;AD0EA;;;EAGE,yBApEoB;ACHtB;;AD0EA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACvEF;;AD0EA;;CAAA;AAIA;EACE,wBA1CU;EA2CV,UA1CS;EA2CT,kBAAA;EACA,aAlDiB;EAmDjB,kBAAA;EACA,mBA3HO;EA4HP,+BAAA;EACA,YAAA;EACA,2BAAA;EACA;;;GAAA;ACrEF;;AD2EA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACxEF;;AD6EA;EACE,2BAAA;AC1EF;;AD6EA;EACE,yBAAA;EACA,YAAA;AC1EF;;AD8EA;EACE,YAAA;AC3EF;;AD8EA;EACE,sBA9GY;ACmCd;;AD8EA;;CAAA;AAGA;EACE,sBArHY;EAsHZ,iBAAA;AC3EF;;AD8EA;EACE,yBArIgB;EAsIhB,iBAAA;AC3EF;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;;CAAA;AAGA;EACE,sBAtIY;AC2Dd;;AD8EA;EACE,yBArJgB;AC0ElB;;AD8EA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;AC3EF;;AD8EA;;CAAA;AAGA;EACE,yBAAA;AC3EF;;AD8EA;EACE,yBA1KgB;AC+FlB;;AD8EA;;CAAA;AAGA;EACE,yBAAA;AC3EF;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;;EAEE,sBAAA;AC3EF;;AD8EA;EACE,yBA5LsB;EA6LtB,cAvMkB;AC4HpB;;AD8EA;EACE,sCAAA;EACA,sBAAA;EACA,oCAAA;AC3EF;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;EACE,sBAAA;EACA,oCAAA;AC3EF;;AD8EA;EACE,0BAAA;AC3EF;;AD8EA;EACE,uBAAA;AC3EF;;AD8EA;EACE,0BAAA;AC3EF;;AD8EA;EACE,uBAAA;AC3EF;;AD8EA;;EAEE,qBAAA;AC3EF;;AD8EA;EACE,yBArOsB;EAsOtB,WA7NY;ACkJd;;AD8EA;;CAAA;AAGA;EACE,cAjOe;ACsJjB;;AD8EA;EACE,cArOe;AC0JjB;;AD8EA;;CAAA;AAGA;EACE,sBA/OY;EAgPZ,YAAA;AC3EF;;AD8EA;EACE,yBA/PgB;EAgQhB,WArPY;EAsPZ,YAAA;AC3EF;;AD8EA;EACE,cAvPe;AC4KjB;;AD8EA;;CAAA;AAGA;EACE,yBA9Sc;EA+Sd,8BAAA;AC3EF;;AD8EA;EACE,WAtQY;AC2Ld;;AD8EA;;EAEE,0BAAA;AC3EF;;AD8EA;;EAEE,0BAAA;AC3EF;;AD8EA;EACE,kBAAA;AC3EF;;AD8EA;EACE,kBAAA;AC3EF;;AD8EA;EACE,oCAAA;EACA,gCAAA;AC3EF;;AD8EA;EACE,yBAzRkB;EA0RlB,WAlSY;ACuNd;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;EACE,iBAAA;AC3EF;;AD8EA;;EAEE,+BAAA;EACA,iBAAA;AC3EF;;AD8EA;EACE,sBApTY;ACyOd;AD6EE;EACE,sBAvTU;EAwTV,YAAA;AC3EJ;AD6EE;EACA,iBAAA;AC3EF;;ADgFA;EACE,0CAAA;EACA,cA/Te;ACkPjB;AD+EE;EACE,yCAAA;EACA,eAAA;AC7EJ;;ADiFA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC9EF;;ADiFA;EACE,yBAAA;EACA,0BAAA;AC9EF;;ADiFA;;CAAA;AAGA;EACE,sBA3VY;EA4VZ,yBAAA;EACA,qDAAA;AC9EF;;ADiFA;EACE,yBAzVkB;EA0VlB,yBAAA;EACA,eAAA;AC9EF;ADgFE;EACE,cAnWa;ACqRjB;;ADmFA;;CAAA;AAGA;EACE,yBAlXgB;ACkSlB;;ADmFA;EACE,yBAAA;EACA,yBAAA;AChFF;;ADmFA;EACE,yBAlYoB;EAmYpB,yBAAA;AChFF;;ADmFA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AChFF;;ADmFA;;CAAA;AAGA;EACE,sBAtYY;ACsTd;;ADmFA;EACE,yBAlYkB;ACkTpB;;ADoFA;;CAAA;AAGA;EACE,iGAAA;EACA,sBAnZY;ACkUd;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;EACE,gGAAA;EACA,sBA5ZY;AC2Ud;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;EACE,gGAAA;EACA,sBAraY;ACoVd;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;EACE,gGAAA;EACA,sBA9aY;AC6Vd;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;;;;;;;;EAQE,WA7bY;AC4Wd;;ADoFA;;CAAA;AAGA;EACE,qCAAA;ACjFF;;ADoFA;EACE,cArce;ACoXjB;;ADqFA;;CAAA;AAGA;EACE,sBAAA;AClFF;;ADqFA;EACE,yBAAA;AClFF;;ADqFA;EACE,yBAzekB;EA0elB,WAzdY;ACuYd;;ADqFA;EACE,yBA9ekB;EA+elB,WA9dY;AC4Yd;;ADqFA;EACE,6BAAA;AClFF;;ADqFA;EACE,2BAAA;AClFF;;ADqFA;EACE,yBA3fkB;ACyapB;;ADqFA;EACE,yBA9fwB;AC4a1B;;ADqFA;EACE,WAlfY;EAmfZ,6BAAA;EACA,yBAAA;AClFF;;ADqFA;EACE,yBAzgBkB;ACubpB;;ADsFA;EACE,yBAxgBgB;ACqblB;;ADsFA;EACE,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,wCAAA;EACA,oCAAA;EACA,yBAAA;EACA,2BAAA;ACnFF;;ADsFA;;;EAGE,oCAAA;EACA,sBAAA;ACnFF;;ADsFA;EACE,gBAAA;EACA,YAAA;EACA,WAphBY;EAqhBZ,yBAhjBY;EAijBZ,YAAA;EACA,eAAA;EACA,gBA3kBc;ACwfhB;;ADsFA;EACE,gBAAA;EACA,YAAA;EACA,WA9hBY;EA+hBZ,yBA1jBY;EA2jBZ,YAAA;EACA,eAAA;EACA,gBArlBc;ACkgBhB;;ADsFA;EACE,yBAjkBY;AC8ed;;ADsFA;EACE,yBA3jBkB;ACwepB;;ADsFA;EACE,yBA9jBwB;AC2e1B;;ADsFA;EACE,cApkBiB;ACifnB;;ADuFA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACpFF;;ADuFA;EACE,WA7jBY;EA8jBZ,yBAzlBY;EA0lBZ,YAAA;ACpFF;;ADuFA;EACE,QAAA;ACpFF;;ADuFA;EACE,gBAAA;EACA,YAAA;EACA,yBA7lBW;EA8lBX,WA1kBY;EA2kBZ,eAAA;EACA,gBA/nBc;EAgoBd,YAAA;ACpFF;;ADuFA;EACE,gBAAA;EACA,YAAA;EACA,yBAvmBW;EAwmBX,WAplBY;EAqlBZ,eAAA;EACA,gBAzoBc;EA0oBd,YAAA;ACpFF;;ADuFA;;EAEE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACpFF;;ADuFA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACpFF;;ADuFA;;;EAGE,yBA9nBW;EA+nBX,WA3mBY;EA4mBZ,YAAA;ACpFF;;ADuFA;EACE,oCAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;ACpFF;;ADuFA;;;EAGE,oCAAA;ACpFF;;ADuFA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACpFF;;ADyFA;EACE,aAAA;EACA,kBAAA;ACtFF;;ADyFA;EACE,mBAAA;ACtFF;;ADyFA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;ACtFF;;ADyFA;EACE,UAAA;ACtFF;;ADyFA;EACE,yCA3qBc;EA4qBd,cAhrBkB;AC0lBpB;;ADyFA;EACE,aAprBkB;AC8lBpB;;ADyFA;EACE,yBAhrBgB;AC0lBlB;;ADyFA;EACE,yBAAA;ACtFF;;ADyFA;EACE,6BAAA;EACA,yBAAA;EACA,WA/qBY;ACylBd;;ADyFA;;EAEE,yBArsBkB;EAssBlB,WArrBY;AC+lBd;;ADyFA;EACE,6BAAA;EACA,yBAAA;EACA,WA3rBY;ACqmBd;;ADyFA;EACE,yBAxsBsB;EAysBtB,WAhsBY;AC0mBd;;ADyFA;;;EAGE,WAtsBY;ACgnBd;;ADyFA;;EAEE,yBAttBgB;EAutBhB,WA5sBY;ACsnBd;;ADyFA;EACE,yBA9vBO;ACwqBT;;ADyFA;EACE,eA/tBgB;ACyoBlB;;ADyFA;EACE,YAxtBY;ACkoBd;;ADyFA;;EAEE,sBAAA;ACtFF;;ADyFA,iBAAA;AAKA;EACE,mBAAA;EACA,gBAAA;AC1FF;;AD6FA;EACE,0BAAA;AC1FF;;AD6FA;EACE,2BAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,uBAAA;AC1FF;;AD6FA;EACE,qBAAA;EACA,iCAAA;EACA,cAAA;AC1FF;;AD6FA;EACE,6BAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;AC1FF;;AD6FA;EACE,cAAA;EACA,WAAA;EACA,0CAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,oEAAA;AC1FF;;AD6FA;;EAEE,0BAAA;EACA,aAAA;AC1FF;;AD6FA;EACE,kBAAA;EACA,kBAAA;AC1FF;;AD6FA;EACE;IACE,gBAAA;EC1FF;AACF;AD6FA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,6BAAA;EC3FF;ED8FA;IACE,uBAAA;IACA,+BAAA;EC5FF;AACF;AD+FA;EACE;;IAAA;AC3FF;ADgGA;EACE;IACE,uBAAA;EC9FF;EDiGA;IACE,6BAAA;EC/FF;AACF;ADkGA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,kCAAA;EChGF;EDmGA;;IAEE,kBAAA;ECjGF;EDoGA;IACE,eAAA;EClGF;EDqGA;IACE,aAAA;ECnGF;EDsGA;IACE,8BAAA;IACA,aAAA;ECpGF;AACF;ADuGA;EACE;IACE,iBAAA;ECrGF;EDwGA;IACE,gBAAA;ECtGF;EDyGA;;KAAA;ACrGF;AD0GA,mBAAA;AAGE;EACE,iCAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AC1GJ;AD2GI;EAPF;IAQI,gBAAA;ECxGJ;AACF;AD2GE;EACE,WAAA;EACA,cAAA;ACzGJ;AD2GI;EACE,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;ACzGN;AD0GM;EAPF;IAQI,iBAAA;IACA,aAAA;IACA,iBAAA;ECvGN;AACF;ADwGM;EACE,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;ACtGR;AD0GI;EACE,WAAA;EACA,cAAA;ACxGN;ADyGA;EACE,cAAA;ACvGF;ADyGM;EACE,WAAA;EACA,mBAAA;ACvGR;ADyGQ;EACE,uEAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;ACvGV;AD0GQ;EACE,kFAAA;ACxGV;AD6GM;EACE,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,SAAA;AC3GR;AD8GM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AC5GR;AD8GQ;EACE,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AC5GV;AD+GQ;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;AC7GV;;ADoHA,mBAAA;AACA;EACI,2BAAA;ACjHJ;;ADoHE;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;EACA,mBAAA;ACjHJ;ADmHI;EATF;IAUI,yBAAA;EChHJ;AACF;ADkHI;EAbF;IAcI,aAAA;IACA,SAAA;IACA,kBAAA;EC/GJ;AACF;ADkHM;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;AChHR;ADoHI;EACE,SAAA;AClHN;ADoHM;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AClHR;ADoHQ;EALF;IAMI,kBAAA;IACA,qBAAA;IACA,WAAA;ECjHR;AACF;ADmHQ;EACE,SAAA;EACA,UAAA;ACjHV;ADmHU;EAJF;IAKI,gCAAA;IACA,sBAAA;EChHV;AACF;ADkHU;EATF;IAUI,mBAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;IACA,mBAAA;EC/GV;AACF;ADiHU;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AC/GZ;ADkHU;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AChHZ;ADqHM;EACE,6BAAA;ACnHR;ADoHQ;EACE,iBAAA;AClHV;ADmHU;EACE,WAAA;ACjHZ;ADkHY;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AChHd;;ADyHC;EACK,aAAA;EACF,2BAAA;EACA,MAAA;EACA,mBAAA;EACA,eAAA;ACtHJ;ADuHI;EANH;IAOK,uBAAA;ECpHJ;AACF;;ADsHA;EACE,gBAAA;ACnHF;ADqHE;EACE,iBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;ACnHJ;ADqHI;EARF;IASI,kBAAA;EClHJ;AACF;ADmHI;EAXF;IAYI,iBAAA;IACA,uBAAA;EChHJ;AACF;ADkHI;EACE,iBAAA;EACA,YAAA;EACA,WAAA;AChHN;ADkHM;EALF;IAMI,4BAAA;EC/GN;AACF;ADkHI;EACE,4BAAA;AChHN;ADoHE;EACE,YAAA;EACA,mBAAA;EACA,cAAA;AClHJ;ADoHI;EALF;IAMI,uBAAA;ECjHJ;AACF;ADmHI;EACE,iBAAA;EACA,YAAA;EACA,WAAA;ACjHN;ADmHM;EALF;IAMI,4BAAA;EChHN;AACF;ADkHI;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AChHN;ADiHM;EARF;IASI,eAAA;EC9GN;AACF;;ADqHA;EACE,yCAAA;EACA,SAAA;EACA,mBAAA;AClHF;ADoHE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;AClHJ;;AA1lCA;EACI,aAAA;EACA,8BAAA;AA6lCJ;AA3lCI;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;AA6lCR;AA1lCI;EACI,UAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;AA4lCR;AA1lCQ;EACI,WAAA;EACA,YAAA;AA4lCZ;;AAxlCA;EAEI,wCAAA;EACA,oCAAA;AA0lCJ;;AAxlCA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cD5BY;EC6BZ,gBAAA;EACA,gBAAA;EACA,kBAAA;AA2lCJ;;AAxlCA;EACI,kBAAA;EACA,kBAAA;EACA,SAAA;AA2lCJ;;AAxlCA;;;EAGI,UDEU;ACylCd;;AAzlCC;EACG,6BAAA;AA4lCJ;;AA1lCA;EACI,6BAAA;AA6lCJ;;AA3lCA;EACI,gBAAA;EACA,eAAA;AA8lCJ;;AA3lCI;EACI,mBAAA;AA8lCR;AA5lCQ;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AA8lCZ;AA3lCQ;EACI,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AA6lCZ;AA1lCQ;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AA4lCZ;AAzlCQ;EACI,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AA2lCZ;AAxlCQ;EACI,aAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;AA0lCZ;AAxlCY;EACI,WAAA;EACA,kBAAA;AA0lChB;AAxlCgB;EACI,WAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;AA0lCpB;AAvlCgB;EACI,SAAA;AAylCpB;AAvlCoB;EACI,eAAA;EACA,gBAAA;AAylCxB;AArlCgB;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;AAulCpB;;AAhlCA;EACI,sBAAA;AAmlCJ;;AAhlCA;EACI,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;AAmlCJ;;AAhlCA;EACI,YAAA;EACA,aAAA;AAmlCJ;;AAhlCA;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AAmlCJ;;AAhlCA;EACI,YAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;AAmlCJ;AAjlCK;EACG,yBAAA;AAmlCR;;AA/kCA;EACI;IACI,gBAAA;IACA,kBAAA;EAklCN;EA/kCE;IACI,gBAAA;EAilCN;AACF","sourcesContent":["/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #131F43;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #F3F4F8;\n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #FAF4FB;\n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #FAF7F3;\n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #F5F9FC;\n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon2-color: #AC44BB;\n$cardIcon3-color: #D69A5F;\n$cardIcon4-color: #176CA5;\n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n$dark-active-blue : #3b82f6;\n$dark-light-blue : #92afd3;\n$addBtn-dark-blue : #3b82f6;\n$addBtn-dark-blue-hover : #2563eb;\n$backBtn-dark : #3b82f633;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131F43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  overflow-y: auto;\n  padding-right: 0px;\n}\n\n.dashboardContain {\n  width: calc(100% - 320px);\n  background-Color: $mainBg;\n  border-radius: 8px;\n}\n\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard,\n.bodythemedark .cont2 {\n  background-Color: $darkTheme_darkBlue;\n}\n\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  /*height: calc(100vh - 160px);*/\n  height: 100%;\n  min-height: auto !important;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n\n\n.cst_vendr input {\n  min-height: 35px !important;\n}\n\n.cst_vendr .form-control {\n  background-color: #f5f6fa;\n  border: none;\n}\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n.bodythemeNew {\n  background-color: #f5f6fa;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 2;\n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: #f5f6fa;\n}\n\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span,\n.menulinklight:hover a {\n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color !important;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color !important;\n}\n\n.menulinklight .sub_arrow svg path {\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path {\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinklight:hover svg path,\n.menulinklightSelected svg path {\n  fill: #fff !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n\n.tableheadlight th {\n  color: $white-color;\n}\n\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n}\n\nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child {\n  border-radius: 0 5px 0px 0;\n}\n\nth:first-child {\n  border-radius: 0px;\n}\n\ntd:last-child {\n  border-radius: 0px;\n}\n\ntable.table.table-borderless {\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n\n.tablebodylight td,\n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 45px;\n}\n\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: $white-color;\n    cursor: auto;\n  }\n  p{\n  line-height: 24px;\n}\n\n}\n\n.tablebodydark {\n  /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: pointer;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a,\n#card1bgdark p,\n#card2bgdark a,\n#card2bgdark p,\n#card3bgdark a,\n#card3bgdark p,\n#card4bgdark a,\n#card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important;\n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border-radius: 5px !important;\n  background-color: transparent !important;\n  border: solid 1px $primary-color !important;\n  color: $primary-color !important;\n  min-width: 113px !important;\n}\n\n.resetbtn:hover,\n.resetbtn:active,\n.resetbtn:focus {\n  background-color: $primary-color !important;\n  color: $white-color !important;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addDltBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important;\n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover,\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color !important;\n  min-width: 130px !important;\n  height: 50px !important;\n  color: $white-color !important;\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border: none !important;\n}\n\n.confirmBtn:hover,\n.confirmBtn:active,\n.confirmBtn:focus {\n  background-color: $darkTheme_darkBlue !important;\n}\n\n.confirmBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n\n\n.delPopContainer .modal-body {\n  padding: 35px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n  padding: 0 20px;\n}\n\n.arrowback svg {\n  fill: #000;\n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark;\n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral,\n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item,\n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input,\n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {}\n\n.modalStyleDark {}\n\n.delPopContainer .modal-content {\n  border-radius: 10px;\n  min-width: 399px;\n}\n\n.larg_model .modal-dialog {\n  max-width: 100% !important;\n}\n\n.larg_model .modal-content {\n  /* display: inline-block; */\n  height: 100%;\n  max-width: 900px;\n  margin: auto;\n  border-radius: 54px !important;\n  background: #FFF;\n  padding: 53px 53px 23px;\n}\n\n.larg_model .modal-header {\n  padding: 0px 0px 23px;\n  border-bottom: 1px dashed #D4D9EE;\n  display: block;\n}\n\nbody .btn-primary:hover {\n  background-color: transparent;\n  border-color: #131F43;\n  color: #131F43;\n  fill: #131F43;\n  border: 1px solid;\n}\n\n.form-select {\n  display: block;\n  width: 100%;\n  padding: .375rem 2.25rem .375rem .75rem;\n  -moz-padding-start: calc(0.75rem - 3px);\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #212529;\n  background-color: #fff;\n  background-image: url(../../assets/select_arow.svg) !important;\n}\n\nthead .CustomTable_tableheadlight__HuHZw th:first-child,\nthead .CustomTable_tableheaddark__nwqb4 th:first-child {\n  border-radius: 5px 0 0 0px;\n  display: math;\n}\n\nth:first-child {\n  border-radius: 0px;\n  position: absolute;\n}\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 270px;\n  }\n}\n\n@media only screen and (max-width: 1024px) {\n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n    overflow-x: hidden !important;\n  }\n\n  .cont2 {\n    height: auto !important;\n    padding-bottom: 10px !important;\n  }\n}\n\n@media only screen and (max-width: 998px) {\n  /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n\n@media only screen and (max-width: 767px) {\n  .sectionright {\n    float: unset !important;\n  }\n\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px 10px 15px !important;\n  }\n\n  .bodythemelight,\n  .bodythemedark {\n    padding-top: 110px;\n  }\n\n  .delPopContainer .modal-content {\n    min-width: 100%;\n  }\n\n  .delPopContainer .modal-body {\n    padding: 15px;\n  }\n\n  .larg_model .modal-content {\n    border-radius: 20px !important;\n    padding: 22px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n    max-width: 1055px;\n  }\n\n  .delPopContainer .modal-dialog {\n    max-width: 350px;\n  }\n\n  /*.tableheadlight th {\n    min-width: 120px;\n  } */\n}\n\n/* vk new changes */\n.active_show_outer {\n\n  h2 {\n    color: var(--Font-black, #0B0D0F);\n    font-family: Urbanist;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    @media screen and (max-width:768px) {\n      margin-top: 15px;\n    }\n  }\n\n  .active_show_inner {\n    width: 100%;\n    display: block;\n\n    .act_box_img {\n      margin-bottom: 12px;\n      min-height: 400px;\n      object-fit: cover;\n      overflow: hidden;\n      height: 400px;\n      max-height: 400px;\n      @media (max-width: 767px) {\n        min-height: 300px;\n        height: 300px;\n        max-height: 300px;\n      }\n      img {\n        max-height: 400px;\n        /* align-self: stretch; */\n        width: 100%;\n        height: 100%;\n        border-radius: 12px;\n        object-fit: cover;\n      }\n    }\n\n    .act_box_cnt {\n      width: 100%;\n      display: block;\nsvg{\n  flex-shrink: 0;\n}\n      .act_box_bdg {\n        width: 100%;\n        margin-bottom: 12px;\n\n        span {\n          background: url(../../assets/ongoing.png) right top no-repeat;\n          width: 111px;\n          display: block;\n          height: 34px;\n          color: var(--White, #FFF);\n          font-size: 18px;\n          font-style: normal;\n          font-weight: 500;\n          padding: 3px 8px;\n        }\n\n        .sold {\n          background: url(../../assets/sold.png) right top no-repeat !important;\n        }\n\n      }\n\n      h3 {\n        color: var(--Secondary, #132941);\n        font-size: 18px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 26.304px;\n        margin: 0;\n      }\n\n      p {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        margin-bottom: 5px;\n\n        span {\n          color: var(--Light-1, #736B66);\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 500;\n          line-height: 26.304px;\n        }\n\n        .timezone_code_pill {\n          display: inline-block;\n          padding: 2px 8px;\n          margin-left: 4px;\n          background: #e0f2fe;\n          color: #0369a1;\n          font-size: 12px;\n          font-weight: 600;\n          letter-spacing: 0.02em;\n          border-radius: 6px;\n        }\n      }\n    }\n  }\n}\n\n/* vk new changes */\n#attent_details_row1{\n    margin-bottom: 0 !important;\n}\n.attent_details {\n  .attent_details_inner {\n    display: flex;\n    gap: 61px;\n    padding: 20px;\n    border-radius: 5px;\n    background: #FFF;\n    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);\n    align-items: center;\n\n    @media (max-width: 576px) {\n      display: block !important;\n    }\n\n    @media (max-width: 992px) {\n      display: flex;\n      gap: 20px;\n      align-items: start;\n    }\n\n    .attent_details_inner_l {\n      img {\n        width: 187px;\n        height: 207px;\n        flex-shrink: 0;\n        object-fit: cover;\n      }\n    }\n\n    .attent_details_inner_r {\n      flex: 1;\n\n      .attent_details_row {\n        display: flex;\n        gap: 20px;\n        margin-bottom: 28px;\n\n        @media (max-width: 992px) {\n          margin-bottom: 0px;\n          display: inline-block;\n          width: 100%;\n        }\n\n        .attent_details_row_box {\n          flex: 1;\n          width: 22%;\n\n          @media (max-width: 576px) {\n            margin: 15px 0px 10px !important;\n            width: 100% !important;\n          }\n\n          @media (max-width: 992px) {\n            margin-bottom: 15px;\n            float: left;\n            margin-right: 0;\n            width: 50%;\n            padding-right: 10px;\n          }\n\n          p {\n            margin-bottom: 10px;\n            color: #727272;\n            font-size: 13px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n          }\n\n          h5 {\n            color: #131F43;\n            font-size: 16px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n            word-wrap: break-word;\n          }\n        }\n      }\n\n      .attent_details_row_last {\n        margin-bottom: 0px !important;\n        &.interesting_fact {\n          padding-top: 30px;\n          .attent_details_row_box {\n            width: 100%;\n            h5 {\n              color: #131F43;\n              font-size: 16px;\n              font-style: normal;\n              font-weight: 500;\n              line-height: 24px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n .showbox_sec{\n      display: flex;\n    justify-content: flex-start;\n    gap: 0;\n    flex-direction: row;\n    flex-wrap: wrap;\n    @media screen and (max-width:500px) {\n      justify-content: center;\n    }\n }\n.show_box_main {\n  margin: 10px 0px;\n\n  .show_box {\n    min-height: 600px;\n    width: 300px;\n    float: left;\n    margin-right: 20px;\n    margin-bottom: 20px;\n    cursor: pointer;\n\n    @media (max-width: 1024px) {\n      margin-right: 18px;\n    }\n    @media (max-width: 767px) {\n      min-height: 500px;\n      width: 200px !important;\n    }\n\n    img {\n      max-height: 400px;\n      height: 100%;\n      width: 100%;\n\n      @media (max-width: 767px) {\n        max-height: 300px !important;\n      }\n    }\n\n    &:last-child {\n      margin-right: 0px !important;\n    }\n  }\n\n  .no_show_box {\n    width: 350px;\n    margin: 0 auto 20px;\n    display: block;\n  \n    @media (max-width: 767px) {\n      width: 250px !important;\n    }\n  \n    img {\n      max-height: 450px;\n      height: 100%;\n      width: 100%;\n  \n      @media (max-width: 767px) {\n        max-height: 350px !important;\n      }\n    }\n    h6 {\n      color: #000;\n      text-align: center;\n      font-size: 26px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n      margin-top: 20px;\n      @media only screen and (max-width: 600px) {\n        font-size: 20px;\n      }\n    }\n  }\n  \n\n}\n\n.attent_flex {\n  justify-content: space-between !important;\n  gap: 30px;\n  align-items: center;\n\n  h5 {\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 700;\n  }\n}","@import \"../../styles/Variables/Variables.scss\";\n\n.pop_head {\n    display: flex;\n    justify-content: space-between;\n\n    h4 {\n        color: #0B0D0F;\n        font-size: 22px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: normal;\n        margin: 0;\n    }\n\n    .pop_close {\n        padding: 0;\n        margin: 0;\n        background: none;\n        border: none !important;\n        cursor: pointer;\n\n        svg {\n            width: 26px;\n            height: 26px;\n        }\n    }\n}\n.pop_close:hover\n{\n    background-color: transparent !important;\n    border-color: transparent !important;\n}\n.resetbtn {\n    font-size: 16px;\n    font-weight: 600;\n    border-radius: 5px;\n    background-color: transparent;\n    border: solid 1px $primary-color;\n    color: $primary-color;\n    min-width: 113px;\n    min-height: 50px;\n    margin-right: 24px;\n}\n\n.resetbtn svg {\n    margin-right: 10px;\n    position: relative;\n    top: -1px;\n}\n\n.resetbtn:hover svg,\n.resetbtn:active svg,\n.resetbtn:focus svg {\n    fill: $white-color;\n}\n .pop_cnt .from_group button {\n    text-align: center !important;\n}\n.from_groupone{\n    text-align: center !important;\n}\n.formthemeStylesec {\n    box-shadow: none;\n    padding: 26px 0;\n}\n.pop_cnt {\n    .from_group {\n        margin-bottom: 30px;\n      \n        label {\n            color: #727272;\n            font-size: 14px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n            margin-bottom: 16px;\n        }\n\n        .from_control {\n            border-radius: 5px;\n            background-color: #F5F6FA;\n            color: #727272;\n            font-size: 16px;\n            font-style: normal;\n            padding: 15px;\n            font-weight: 500;\n            line-height: normal;\n            height: 50px;\n            width: 100%;\n            border: none;\n        }\n\n        ::placeholder {\n            color: #727272;\n            font-size: 16px;\n            font-style: normal;\n            font-weight: 500;\n            line-height: normal;\n        }\n\n        .drag_label {\n            color: #727272;\n            font-size: 10.184px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n        }\n     \n        .image_drag {\n            display: flex;\n            width: 100%;\n            height: 219.693px;\n            padding: 0 15px;\n            flex-direction: column;\n            align-items: center;\n            gap: 7.275px;\n            border-radius: 3.637px;\n            background: #F5F6FA;\n\n            .image_drag_inner {\n                width: 100%;\n                text-align: center;\n\n                label {\n                    width: 100%;\n                    height: 219.693px;\n                    display: flex;\n                    justify-content: center;\n                    flex-direction: column;\n                }\n\n                h6 {\n                    margin: 0;\n\n                    svg {\n                        width: 40.738px;\n                        height: 40.738px;\n                    }\n                }\n\n                h5 {\n                    color: #727272;\n                    font-size: 14px;\n                    font-style: normal;\n                    font-weight: 600;\n                    margin: 0;\n                    line-height: normal;\n                }\n            }\n        }\n    }\n}\n\n.from_group :global(.addBtn:hover) {\n    color: #fff !important;\n}\n\n.upload_btn{\n    display: inline-block;\n    border: 1px solid #ced4da;\n    color: #60677e;\n    padding: 5px 10px;\n    font-size: 14px;\n    border-radius: 5px;\n    cursor: pointer;\n  }\n\n.uploaded_imgsection{\n    width: 100px;\n    height: 150px;\n}\n\n#uploaded_img{\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.imgcancel_btn{\n    border: none;\n    font-size: 14px;\n    padding: 5px 30px;\n    background-color: #e2e3e7;\n    margin-top: 5px;\n    border-radius: 5px;\n\n     &:hover{\n        background-color: #a9a9a9;\n     }\n}\n\n@media only screen and (max-width: 360px) {\n    .resetbtn {\n        min-width: 100px;\n        margin-right: 15px;\n    }\n\n    .deleteBtn {\n        min-width: 100px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `popUp_dashboard__3Ij9R`,
	"dashboardContain": `popUp_dashboardContain__V602m`,
	"bodythemedark": `popUp_bodythemedark__nZv4W`,
	"cont2": `popUp_cont2__BCPQ-`,
	"top_header": `popUp_top_header__8GWXZ`,
	"top_header_inner": `popUp_top_header_inner__fiq7r`,
	"subLink": `popUp_subLink__KX4-k`,
	"cst_vendr": `popUp_cst_vendr__9Wow3`,
	"form-control": `popUp_form-control__YvXVG`,
	"footer": `popUp_footer__ZUYud`,
	"bodythemelight": `popUp_bodythemelight__pD1y9`,
	"bodythemeNew": `popUp_bodythemeNew__Ytun1`,
	"headerthemelight": `popUp_headerthemelight__d3vR2`,
	"headerthemedark": `popUp_headerthemedark__1+ZIW`,
	"menuthemelight": `popUp_menuthemelight__EUIuy`,
	"menuthemedark": `popUp_menuthemedark__zXXQk`,
	"menulinklight": `popUp_menulinklight__wLERK`,
	"menulinkdarkSelected": `popUp_menulinkdarkSelected__OnjGw`,
	"menulinklightSelected": `popUp_menulinklightSelected__1R1za`,
	"menulinkdark": `popUp_menulinkdark__4cS5c`,
	"sub_arrow": `popUp_sub_arrow__2mF5H`,
	"headinglight": `popUp_headinglight__OPKl3`,
	"headingdark": `popUp_headingdark__C2zJq`,
	"searchboxlight": `popUp_searchboxlight__EnlnJ`,
	"searchboxdark": `popUp_searchboxdark__RFGE6`,
	"tableheadlight": `popUp_tableheadlight__ANyxy`,
	"tableheaddark": `popUp_tableheaddark__oLS07`,
	"table": `popUp_table__maPf9`,
	"table-borderless": `popUp_table-borderless__ngQfF`,
	"left-section": `popUp_left-section__2+ivL`,
	"tablebodylight": `popUp_tablebodylight__r-oh1`,
	"tablebodydark": `popUp_tablebodydark__UVOm9`,
	"paginationlight": `popUp_paginationlight__ndAsc`,
	"paginationdark": `popUp_paginationdark__1xGwh`,
	"formthemelight": `popUp_formthemelight__Vk1OI`,
	"formthemedark": `popUp_formthemedark__aQbIu`,
	"viewformlight": `popUp_viewformlight__WGO5b`,
	"permissionboxlight": `popUp_permissionboxlight__oCdaW`,
	"permissionboxdark": `popUp_permissionboxdark__ECH20`,
	"errormsgclr": `popUp_errormsgclr__Oraf6`,
	"graphclrlight": `popUp_graphclrlight__f57pk`,
	"graphclrdark": `popUp_graphclrdark__-SN00`,
	"card1bglight": `popUp_card1bglight__J6dAZ`,
	"card1bgdark": `popUp_card1bgdark__p1Sbz`,
	"card2bglight": `popUp_card2bglight__Lluls`,
	"card2bgdark": `popUp_card2bgdark__XMlZp`,
	"card3bglight": `popUp_card3bglight__4-tEj`,
	"card3bgdark": `popUp_card3bgdark__LRWE1`,
	"card4bglight": `popUp_card4bglight__KdKB6`,
	"card4bgdark": `popUp_card4bgdark__V5sbe`,
	"actionbtnlight": `popUp_actionbtnlight__dsGjO`,
	"actionbtndark": `popUp_actionbtndark__aGBaO`,
	"profiledropdownlight": `popUp_profiledropdownlight__lEFlW`,
	"profiledropdowndark": `popUp_profiledropdowndark__VgGri`,
	"settingsection": `popUp_settingsection__qcJda`,
	"addform": `popUp_addform__pHtis`,
	"savebtn": `popUp_savebtn__H5Vpd`,
	"profile_conatiner": `popUp_profile_conatiner__ZnC5R`,
	"ag-theme-alpine": `popUp_ag-theme-alpine__midEU`,
	"ag-row": `popUp_ag-row__Y5pQu`,
	"formbtn": `popUp_formbtn__VxNBo`,
	"resetbtn": `popUp_resetbtn__mHYqk`,
	"addBtn": `popUp_addBtn__Kuvu2`,
	"addDltBtn": `popUp_addDltBtn__02gc4`,
	"addbtnlight": `popUp_addbtnlight__yS-uI`,
	"addbtndark": `popUp_addbtndark__I3s-O`,
	"cust_addBtn": `popUp_cust_addBtn__BJ8f6`,
	"deleteBtn": `popUp_deleteBtn__LO2TU`,
	"confirmBtn": `popUp_confirmBtn__tqH8G`,
	"delPopContainer": `popUp_delPopContainer__7Ojbb`,
	"modal-body": `popUp_modal-body__7h3Gn`,
	"delet_icon": `popUp_delet_icon__XqV-q`,
	"arrowback": `popUp_arrowback__LBq8d`,
	"drpdwn_btn": `popUp_drpdwn_btn__Oils+`,
	"empname": `popUp_empname__xTq2C`,
	"navitemli": `popUp_navitemli__heV5-`,
	"tabnavli": `popUp_tabnavli__uxVyN`,
	"settingsgeneral": `popUp_settingsgeneral__1T7YT`,
	"settingslinks": `popUp_settingslinks__JSeOh`,
	"dropdown_menu_contain": `popUp_dropdown_menu_contain__9GtSg`,
	"dropdown_item": `popUp_dropdown_item__0mnfC`,
	"profile_arrrow_dwn": `popUp_profile_arrrow_dwn__g2FtD`,
	"dateinputbox1": `popUp_dateinputbox1__rdLzw`,
	"modal-content": `popUp_modal-content__BzrXf`,
	"larg_model": `popUp_larg_model__zvTr0`,
	"modal-dialog": `popUp_modal-dialog__qYhPE`,
	"modal-header": `popUp_modal-header__de44j`,
	"btn-primary": `popUp_btn-primary__tzQj2`,
	"form-select": `popUp_form-select__WysRJ`,
	"CustomTable_tableheadlight__HuHZw": `popUp_CustomTable_tableheadlight__HuHZw__XxSbr`,
	"CustomTable_tableheaddark__nwqb4": `popUp_CustomTable_tableheaddark__nwqb4__z6gn7`,
	"sectionright": `popUp_sectionright__YFeeu`,
	"exer_modal_contain": `popUp_exer_modal_contain__ZZRQD`,
	"active_show_outer": `popUp_active_show_outer__Ond1F`,
	"active_show_inner": `popUp_active_show_inner__3Fg48`,
	"act_box_img": `popUp_act_box_img__uWXDH`,
	"act_box_cnt": `popUp_act_box_cnt__OuM3J`,
	"act_box_bdg": `popUp_act_box_bdg__Fzt3y`,
	"sold": `popUp_sold__C1TUM`,
	"timezone_code_pill": `popUp_timezone_code_pill__+BfgM`,
	"attent_details_row1": `popUp_attent_details_row1__OmW1Q`,
	"attent_details": `popUp_attent_details__oY7LF`,
	"attent_details_inner": `popUp_attent_details_inner__4TV6V`,
	"attent_details_inner_l": `popUp_attent_details_inner_l__22Rj8`,
	"attent_details_inner_r": `popUp_attent_details_inner_r__EvMDI`,
	"attent_details_row": `popUp_attent_details_row__UBvk2`,
	"attent_details_row_box": `popUp_attent_details_row_box__Co+rI`,
	"attent_details_row_last": `popUp_attent_details_row_last__yThjj`,
	"interesting_fact": `popUp_interesting_fact__VtS2n`,
	"showbox_sec": `popUp_showbox_sec__cvztP`,
	"show_box_main": `popUp_show_box_main__u8eKG`,
	"show_box": `popUp_show_box__4KLoV`,
	"no_show_box": `popUp_no_show_box__BXtSG`,
	"attent_flex": `popUp_attent_flex__N+p3a`,
	"pop_head": `popUp_pop_head__B9w2T`,
	"pop_close": `popUp_pop_close__bbeGt`,
	"pop_cnt": `popUp_pop_cnt__hshzK`,
	"from_group": `popUp_from_group__1+kyU`,
	"from_groupone": `popUp_from_groupone__u5n0x`,
	"formthemeStylesec": `popUp_formthemeStylesec__rdidi`,
	"from_control": `popUp_from_control__f7OII`,
	"drag_label": `popUp_drag_label__iSKS6`,
	"image_drag": `popUp_image_drag__OJ-Pw`,
	"image_drag_inner": `popUp_image_drag_inner__2RTI1`,
	"upload_btn": `popUp_upload_btn__oB21G`,
	"uploaded_imgsection": `popUp_uploaded_imgsection__ETzXB`,
	"uploaded_img": `popUp_uploaded_img__E3uJL`,
	"imgcancel_btn": `popUp_imgcancel_btn__gQW95`
};
export default ___CSS_LOADER_EXPORT___;
